var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVersionsIconGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3189:51004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.5C12.2235 5.5 12 5.276 12 5V2.2515C12 1.837 12.337 1.5 12.7515 1.5H15.5C15.7765 1.5 16 1.724 16 2C16 2.276 15.7765 2.5 15.5 2.5H13V5C13 5.276 12.7765 5.5 12.5 5.5Z",
    fill: "rgba(5, 125, 136, 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16C3.589 16 0 12.411 0 8C0 3.589 3.589 0 8 0C8.276 0 8.5 0.224 8.5 0.5C8.5 0.776 8.276 1 8 1C4.14 1 1 4.14 1 8C1 11.86 4.14 15 8 15C11.86 15 15 11.86 15 8C15 6.13 14.272 4.3725 12.9495 3.0505C12.754 2.8555 12.754 2.539 12.9495 2.3435C13.145 2.148 13.461 2.148 13.6565 2.3435C15.168 3.854 16 5.863 16 8C16 12.411 12.411 16 8 16Z",
    fill: "rgba(5, 125, 136, 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.5H8C7.724 8.5 7.5 8.276 7.5 8V4C7.5 3.724 7.724 3.5 8 3.5C8.276 3.5 8.5 3.724 8.5 4V7.5H10.5C10.7765 7.5 11 7.724 11 8C11 8.276 10.7765 8.5 10.5 8.5Z",
    fill: "rgba(5, 125, 136, 1)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3189:51004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVersionsIconGreen);
export default __webpack_public_path__ + "static/media/versions-icon-green.c83110b371f59dc2e707884d9145b01f.svg";
export { ForwardRef as ReactComponent };